import styled, { css } from "styled-components"
import { error } from "styles/theme"

const WrapTestTakerForm = styled.div`
padding:2px;

.wrap-error-list{
color:${error};
}
`

const TestTakerForm = css`
`

export { TestTakerForm, WrapTestTakerForm }